import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminSidebarComponent } from '../../components/sidebars/admin-sidebar/admin-sidebar.component';
import { Drawer } from 'primeng/drawer';
import { NotificationBarComponent } from '../../components/notification-bar/notification-bar.component';

@Component({
  selector: 'dt-admin-layout',
  imports: [
    RouterOutlet,
    AdminSidebarComponent,
    Drawer,
    NotificationBarComponent,
  ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminLayoutComponent {
  drawerVisible = signal(false);
}
